import { render, staticRenderFns } from "./TestGeneral.vue?vue&type=template&id=165f06f4&"
import script from "./TestGeneral.vue?vue&type=script&lang=js&"
export * from "./TestGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports